import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import Media from 'react-media';

import { Jumbotron } from '../../ui';

const HeroBanner = props => {
  const {
    heroBannerTexte,
    enSavoirPlus,
    heroImage,
    heroImageSmall,
    link,
  } = props;

  return (
    <Jumbotron
      title="Offshore Services"
      subtitle={heroBannerTexte}
      buttonText={enSavoirPlus}
      link={link}
    >
      <Media query={{ minWidth: '768px' }}>
        {matches =>
          matches ? (
            // si plus grand que 768px =>
            <Img alt={heroImage.title} sizes={heroImage.sizes} />
          ) : (
            <Img alt={heroImageSmall.title} sizes={heroImageSmall.sizes} />
          )
        }
      </Media>
    </Jumbotron>
  );
};

HeroBanner.propTypes = {
  heroBannerTexte: PropTypes.string,
  enSavoirPlus: PropTypes.string,
  heroImage: PropTypes.object,
  heroImageSmall: PropTypes.object,
};

export default HeroBanner;



// WEBPACK FOOTER //
// ./src/components/Main/home/HeroBanner.js